<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import native from "@/native";

/**
 * Exclusao de conta.
 *
 * POR QUE ESTA TELA EXISTE
 * A diretriz 5.1.1(v) da App Store obriga: aplicativo que permite CRIAR conta
 * precisa oferecer, DENTRO do aplicativo, um caminho visivel para EXCLUIR a
 * conta. Este painel tem cadastro publico, entao a regra vale — e o revisor
 * costuma procurar por ela. Sem isso, a reprovacao e praticamente certa.
 *
 * O QUE ELA FAZ
 * Registra uma SOLICITACAO. Nada e apagado na hora, e a tela diz isso com todas
 * as letras. Consultor tem comissao, contrato, nota fiscal e posicao na rede
 * amarrados ao cadastro; o que se apaga e o que a lei obriga a guardar e
 * decisao de negocio, ainda pendente (ver 03-execucao.md).
 *
 * Deixar claro na propria tela o que acontece e quanto tempo leva e o que
 * mantem esse caminho honesto — e aceito pelas duas lojas.
 */
export default {
  locales: {
    pt: {},
    es: {},
  },
  components: { Layout },
  data() {
    return {
      loading: true,
      enviando: false,
      confirmacao: "",
      motivo: "",
      prazo: 30,
      pedido: null,
      alerta: { tipo: "", texto: "" },
    };
  },
  computed: {
    podeEnviar() {
      return (
        !this.enviando &&
        !this.pedido &&
        this.confirmacao.trim().toUpperCase() === "EXCLUIR"
      );
    },
  },
  methods: {
    carregar() {
      api
        .get("user/account-deletion")
        .then((response) => {
          if (response.data.status === "success") {
            this.pedido = response.data.request;
            this.prazo = response.data.prazo || 30;
          }
        })
        .catch(() => {
          this.alerta = {
            tipo: "alert-warning",
            texto:
              "Nao conseguimos consultar a situacao agora. Verifique sua conexao e recarregue a tela.",
          };
        })
        .finally(() => {
          this.loading = false;
        });
    },
    solicitar() {
      if (!this.podeEnviar) {
        return;
      }

      this.enviando = true;
      this.alerta = { tipo: "", texto: "" };

      api
        .post("user/account-deletion", { reason: this.motivo })
        .then((response) => {
          if (response.data.status === "success") {
            native.haptic("warning");
            this.alerta = { tipo: "alert-success", texto: response.data.message };
            this.confirmacao = "";
            this.carregar();
          } else {
            this.alerta = { tipo: "alert-danger", texto: response.data.message };
          }
        })
        .catch(() => {
          this.alerta = {
            tipo: "alert-danger",
            texto:
              "Nao foi possivel registrar a solicitacao. Tente de novo ou abra um chamado no suporte.",
          };
        })
        .finally(() => {
          this.enviando = false;
        });
    },
  },
  mounted() {
    this.carregar();
  },
};
</script>

<template>
  <Layout>
    <div class="page-title-box mb-3">
      <h3>Excluir minha conta</h3>
    </div>

    <div class="row">
      <div class="col-lg-8 col-md-12">
        <div class="card">
          <div class="card-body">
            <div v-if="alerta.texto" :class="'alert ' + alerta.tipo">{{ alerta.texto }}</div>

            <div v-if="loading" class="text-muted">Carregando...</div>

            <template v-else-if="pedido">
              <div class="alert alert-info mb-0">
                <strong>Sua solicitacao ja foi registrada em {{ pedido.date }}.</strong><br />
                Nossa equipe conclui a exclusao em ate {{ prazo }} dias e avisa voce por e-mail.
                Se mudou de ideia, abra um chamado no suporte pedindo o cancelamento.
              </div>
            </template>

            <template v-else>
              <p>
                Ao solicitar a exclusao, sua conta sai do ar e voce perde o acesso ao painel e
                ao aplicativo. A solicitacao e analisada pela nossa equipe e concluida em ate
                <strong>{{ prazo }} dias</strong>.
              </p>

              <div class="alert alert-warning">
                <strong>Leia antes de continuar.</strong>
                <ul class="mb-0 pl-3">
                  <li>A exclusao nao e imediata nem automatica.</li>
                  <li>
                    Alguns dados precisam ser guardados por obrigacao legal e fiscal — notas
                    fiscais, contratos assinados e registros de pagamento, por exemplo.
                  </li>
                  <li>Comissoes ainda nao pagas devem ser resolvidas antes da exclusao.</li>
                  <li>Esta acao nao pode ser desfeita pelo aplicativo.</li>
                </ul>
              </div>

              <div class="form-group">
                <label>Por que voce quer excluir? <small class="text-muted">(opcional)</small></label>
                <textarea
                  v-model="motivo"
                  class="form-control"
                  rows="3"
                  maxlength="500"
                  placeholder="Nos ajuda a melhorar"
                ></textarea>
              </div>

              <div class="form-group">
                <label class="text-danger">Digite EXCLUIR para confirmar</label>
                <input v-model="confirmacao" type="text" class="form-control" autocomplete="off" />
              </div>

              <button
                type="button"
                class="btn btn-danger"
                :disabled="!podeEnviar"
                @click="solicitar"
              >
                {{ enviando ? "Enviando..." : "Solicitar exclusao da conta" }}
              </button>
            </template>
          </div>
        </div>

        <p class="text-muted small">
          Duvidas sobre como tratamos seus dados? Leia a
          <a href="/privacidade" target="_blank" rel="noopener">politica de privacidade</a>.
        </p>
      </div>
    </div>
  </Layout>
</template>
